import { render, staticRenderFns } from "./AppGoToTop.vue?vue&type=template&id=98b73a98"
import script from "./AppGoToTop.vue?vue&type=script&lang=js"
export * from "./AppGoToTop.vue?vue&type=script&lang=js"
import style0 from "./AppGoToTop.vue?vue&type=style&index=0&id=98b73a98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports